module.exports = __webpack_public_path__ + "img/tips-mountain.32030233.svg";